import { useState } from "react";
import { useDispatch } from "react-redux";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Fingerprint, X } from "lucide-react";
import { EnableBiometricAPI } from "../features/auth/authAPI";
import { NativeBiometric } from "capacitor-native-biometric";
import { FormattedMessage } from "react-intl";

const BiometricPrompt = ({ onClose, credentials }) => {
  const dispatch = useDispatch();
  const [isEnabling, setIsEnabling] = useState(false);

  const handleEnableBiometric = async () => {
    debugger;
    setIsEnabling(true);
    try {
      // Take biometric authentication
      await NativeBiometric.verifyIdentity({
        reason: "Please verify your identity to enable biometric login",
        title: "Enable Biometric Authentication",
        subtitle: "Set up biometric login for future use",
      });

      // Save username and password
      await dispatch(EnableBiometricAPI(credentials));
      onClose(true); // Success
    } catch (error) {
      console.error("Biometric setup failed:", error);
      onClose(false); // Failed
    } finally {
      setIsEnabling(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="!p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">
              <FormattedMessage
                id="login.BiometricLogin"
                defaultMessage="Set Up Quick Access?"
              />
            </h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onClose(false)}
              className="p-1"
              disabled={isEnabling}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>

          <div className="text-center">
            <Fingerprint className="w-16 h-16 mx-auto mb-4 text-green-600" />
            <p className="text-gray-600 mb-6">
              <FormattedMessage
                id="login.LoginWithBiometrics"
                defaultMessage="Simplify your sign-in process. Enable biometric login for quick and secure access."
              />
            </p>

            <div className="space-y-3">
              <Button
                onClick={handleEnableBiometric}
                disabled={isEnabling}
                className="w-full bg-green-600 hover:bg-green-700"
              >
                {isEnabling ? (
                  <FormattedMessage
                    id="login.settingUp"
                    defaultMessage="Setting up..."
                  />
                ) : (
                  <FormattedMessage
                    id="login.enable"
                    defaultMessage="Yes, Set It Up"
                  />
                )}
              </Button>

              <Button
                onClick={() => onClose(false)}
                variant="outline"
                className="w-full"
                disabled={isEnabling}
              >
                <FormattedMessage
                  id="login.Skip"
                  defaultMessage="No, skip for now"
                />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BiometricPrompt;
